import { FC } from 'react';

import Chip from '@/components/chip';
import NoneChip from '@/components/chip/none-chip';
import ReadonlyView from '@/components/form/readonly-view';
import { ReadonlyField } from '@/components/form/readonly-view/helpers';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { Stack } from '@mui/material';
import { GroupMeta } from '@/lib/models/group.model';
import PolicyCardList from '@/components/policy-card-list';

interface Props {
  groups: GroupMeta[];
  policies: PolicyModelV1[];
}

const fields: ReadonlyField[] = [
  { label: 'Workforce AI Security Groups', prop: 'adminGroups' },
  { label: 'Policies', prop: 'groups-section', propType: 'section' },
];

const getReadonlyData = (groups: GroupMeta[]) => {
  const adminGroups = groups.filter(({ isExternal }) => !isExternal);

  return {
    adminGroups: adminGroups.length ? (
      <Stack direction="row" gap={1} flexWrap="wrap">
        {adminGroups.map(({ id, name }) => (
          <Chip key={id} label={name} />
        ))}
      </Stack>
    ) : (
      <NoneChip />
    ),
  };
};

export const UserPolicies: FC<Props> = ({ groups, policies }) => {
  return (
    <>
      <ReadonlyView fields={fields} data={getReadonlyData(groups)} />

      <PolicyCardList policies={policies} />
    </>
  );
};

export default UserPolicies;
